module.exports = __webpack_public_path__ + "static/media/workstation_side.8af05dc7.jpg";